/**
 *  If the metadata applies to a person it should only be asked once per
 *  person / ticket, if it applies to a product it should be asked for
 *  every product that’s in the cart *(cartProduct)*.
 */
export var MetadataAppliesTo;
(function (MetadataAppliesTo) {
    MetadataAppliesTo["Person"] = "person";
    MetadataAppliesTo["Product"] = "product";
})(MetadataAppliesTo || (MetadataAppliesTo = {}));
/**
 *  The type of data the metadata should be answered with. Most are basic data
 *  types and straightforward, some need a bit of clarification.
 *
 *  | Type          | Required input                |
 *  | :------------ | :---------------------------- |
 *  | `enumOther`   | Select or manual input        |
 *  | `values`      | Multiselect                   |
 *
 *  The `seatSelect` is used for [Seats](https://www.seats.io/) integration and are
 *  handled by the API separately, so you can ignore it.
 */
export var MetadataType;
(function (MetadataType) {
    MetadataType["Integer"] = "integer";
    MetadataType["String"] = "string";
    MetadataType["Date"] = "date";
    MetadataType["Enum"] = "enum";
    MetadataType["EnumOther"] = "enumOther";
    MetadataType["Boolean"] = "boolean";
    MetadataType["Values"] = "values";
    MetadataType["SeatSelect"] = "seatSelect";
    MetadataType["Phone"] = "phone";
})(MetadataType || (MetadataType = {}));
//# sourceMappingURL=types.js.map